/**
 * Evenement émis pour demander la fermeture de l'onglet d'un dossier.
 */
export class FolderCloseTabRequestEvent {
    /**
     * Constructeur.
     * @param folderId : Id du dossier à fermer.
     * @param isFolderRemoved : Valeur indiquant si le dossier a été retiré de la source de donnée persistente (CESAR STORAGE ou ElasticSearch).
     */
    public constructor(
        public folderId: string,
        public isFolderRemoved: boolean = false
    ) {}
}
